import { getDealRiskV2, type DealRiskIconKind } from '@/components/DealsV2/kanbanCardV2Utils'
import type { Deal } from '@/types'
import { getDirectProposalPendingAlert } from './directProposalJourneyAlert.util'

export type DealCardRisk = {
  label: string
  tone: 'info' | 'warning' | 'danger' | null
  icon: DealRiskIconKind | null
}

export function resolveDealCardRisk(deal: Deal): DealCardRisk {
  const proposalAlert = getDirectProposalPendingAlert(deal)
  if (proposalAlert) {
    return { label: proposalAlert.label, tone: proposalAlert.tone, icon: 'alert' }
  }
  return getDealRiskV2(deal)
}
